import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a15f9c92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Preencha as variáveis para a resposta:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OpcaoComponent = _resolveComponent("OpcaoComponent")!
  const _component_VariavelComponent = _resolveComponent("VariavelComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("article", null, [
      _createElementVNode("header", null, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.minhaQuestao.getTitulo()), 1),
        (_ctx.minhaQuestao.getSubtitulo())
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.minhaQuestao.getSubtitulo()), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minhaQuestao.opcoes, (opcao) => {
          return (_openBlock(), _createBlock(_component_OpcaoComponent, {
            key: opcao.getId(),
            "model-value": _ctx.minhaQuestao.getValorSelecionado() as Opcao,
            opcao: opcao as Opcao,
            questaoId: _ctx.minhaQuestao.getId(),
            onOpcaoSelecionada: _ctx.receberOpcaoSelecionada
          }, null, 8, ["model-value", "opcao", "questaoId", "onOpcaoSelecionada"]))
        }), 128))
      ]),
      (_ctx.minhaQuestao.getValorSelecionado()?.getVariaveis())
        ? (_openBlock(), _createElementBlock("footer", _hoisted_2, [
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minhaQuestao
                        .getValorSelecionado()
                        ?.getVariaveis(), (variavel) => {
              return (_openBlock(), _createBlock(_component_VariavelComponent, {
                key: variavel.getId(),
                variavel: variavel,
                valor: variavel.getValor(),
                "onUpdate:valor": ($event: any) => (variavel.setValor($event))
              }, null, 8, ["variavel", "valor", "onUpdate:valor"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}